export default __webpack_public_path__ + "static/media/launched.0f157ddc.jpg";